import React from 'react'
import { AdvisorData, Certification, RoboAdvisorData } from '../../../utils/types'
import { AdvisorPhotoProfile } from './AdvisorPhotoProfile'
import { AdvisorStats } from './AdvisorStats'
import { RoboAdvisorContent } from './RoboAdvisorContent'
import { NonRoboAdvisorContent } from './NonRoboAdvisorContent'
import { AdvisorCardProvider } from './AdvisorCardContext'
import { isRoboAdvisorData } from './advisorTypeGuards'
import { useModuleConfig } from '../../hooks/useModuleConfig'
import { ADVISOR_CARDS_DEFAULTS, MODULE_KEYS } from '../../moduleRegistry'
import '../../styles/AdvisorCardsModule/AdvisorCard.scss'

interface AdvisorCardProps {
  advisorData: AdvisorData | RoboAdvisorData
  position: number
}

export const AdvisorCard = ({ advisorData, position }: AdvisorCardProps) => {
  const { typeLabels, feeStructureTooltips, ctaLabels } = useModuleConfig(MODULE_KEYS.advisorCards, ADVISOR_CARDS_DEFAULTS)
  const certifications: Certification[] = 'new_certifications' in advisorData.advisor
    ? (advisorData.advisor as { new_certifications: Certification[] }).new_certifications
    : []

  return (
    <AdvisorCardProvider advisorData={advisorData} certifications={certifications} typeLabels={typeLabels}
                         feeStructureTooltips={feeStructureTooltips} ctaLabels={ctaLabels} position={position}>
      <div className='advisor-card'>
        <AdvisorPhotoProfile/>
        <AdvisorStats/>
        {isRoboAdvisorData(advisorData)
          ? <RoboAdvisorContent/>
          : <NonRoboAdvisorContent/>
        }
      </div>
    </AdvisorCardProvider>
  )
}
